"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _withSizePresets = _interopRequireDefault(require("./withSizePresets"));
/* eslint-disable max-len */

var UploadLogoImgIcon = function UploadLogoImgIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({
    viewBox: "0 0 20 22"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_2165_14246)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1201 9.19867V16.8011H5.92012V9.19867H1.12012L9.52012 1.12109L17.9201 9.19867H13.1201Z",
    fill: "none",
    stroke: "#F96302",
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.9201 19.0411H1.12012V21.2811H17.9201V19.0411Z",
    fill: "#F96302"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_2165_14246"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "19.04",
    height: "21.28",
    fill: "white"
  }))));
};
var _default = (0, _withSizePresets["default"])(20, 22)(UploadLogoImgIcon);
exports["default"] = _default;
//# sourceMappingURL=UploadLogoImgIcon.js.map